<template>
<div class="chapter">
<div class="inner_page">
<section class="dedication" epub:type="dedication">
<p class="centred_top_space firstInSection"><em>To Marjory</em></p>
<p class="centred"><em>who was with me every step of the way</em></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?eff5e9aa